import { createAsyncThunk } from '@reduxjs/toolkit';
import { MonitorSummary } from 'features/admin-monitoring/monitorType';
import { reportApiError } from 'features/shared/reportApiError';
import api from 'libs/api';
import { AsyncThunkConfig } from 'store/types';

export const getMonitors = createAsyncThunk<
  MonitorSummary[],
  void,
  AsyncThunkConfig
>(
  'monitoringDirectory/getMonitors',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.monitor.getMonitors();

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);
